module.exports = __WEBPACK_EXTERNAL_MODULE_37__;


/*****************
 ** WEBPACK FOOTER
 ** external "moment"
 ** module id = 37
 ** module chunks = 0
 **/